import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SettingsService} from './settings.service';
import {UntypedFormControl} from '@angular/forms';
import {translate} from '@ngneat/transloco';
import {delay, shareReplay, tap} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import * as messagingActions from '../../../messaging/src/messaging.actions';
import {selectAllActiveTemplatesAlphabetically} from '../../../journal/src/_selectors/template-entity.selectors';

@Injectable({
	providedIn: 'root'
})
export class SettingsManageService {
	private allHelpVisible = false;
	helpToggled = new BehaviorSubject<boolean>(false);
	templates$ = this.store.select(selectAllActiveTemplatesAlphabetically)
		.pipe(shareReplay());

	constructor(
		private settings: SettingsService,
		private store: Store
		) {}

	toggleHelp() {
		this.allHelpVisible = !this.allHelpVisible;
		this.helpToggled.next(this.allHelpVisible);
	}

	bindSettingProperty(prefix: string, key: string, formRef: Map<string, UntypedFormControl>) {
		const settingKey = `${prefix}.${key}`;
		const control = new UntypedFormControl(this.settings.getValue(settingKey));
		control.valueChanges.pipe(
			tap(val => {
				this.settings.setValue(settingKey, val);
				const message = settingKey.split('.').splice(-1).join();
				this.store.dispatch(messagingActions.sendSuccess({message: translate(`journal.settingsBar.${message}`)}));
			}),
			delay(1000)
		).subscribe(() => {
			this.store.dispatch(messagingActions.sendSuccess({message: translate('journal.settingsBar.settingsInfo')}));
		});
		formRef.set(key, control);
	}
}
